import { UserParticipationStatus } from '@core-http';
import { GameParticipationStatusLabel } from '../interfaces';

export const gameParticipationStatusLabelMapper: Record<UserParticipationStatus, GameParticipationStatusLabel> = {
  [UserParticipationStatus.Applied]: {
    iconName: 'game-status-waiting',
    displayName: 'Oczekująca',
    bgColor: '#DFE0FF',
    textColor: '#0066A6'
  },
  [UserParticipationStatus.Approved]: {
    iconName: 'game-status-approved',
    displayName: 'Potwierdzona',
    bgColor: '#EDFBF9',
    textColor: '#43A047'
  },
  [UserParticipationStatus.Invited]: {
    iconName: 'game-status-invitation',
    displayName: 'Zaproszenie',
    bgColor: '#E8E8FF',
    textColor: '#669BFF'
  },
  [UserParticipationStatus.Host]: { iconName: '', displayName: '', bgColor: '', textColor: '' },
  [UserParticipationStatus.Moderator]: { iconName: '', displayName: '', bgColor: '', textColor: '' },
  [UserParticipationStatus.Empty]: { iconName: '', displayName: '', bgColor: '', textColor: '' }
};

export const privateGameLabel: GameParticipationStatusLabel = {
  iconName: 'eye-off',
  displayName: 'Prywatna',
  bgColor: '#EAEAEA',
  textColor: '#717492'
};
